import { ElementId } from './element-id-enum';
import { RowId } from './row-id-enum';

export const DEPS_FIELDS: Readonly<
  Readonly<{
    id: RowId;
    immobiliareWeight: number;
    altriWeight: number;
  }>[]
> = [
  {
    id: RowId.debitoFinanziarioLordoEbitda,
    immobiliareWeight: 5,
    altriWeight: 20,
  },
  { id: RowId.loanToValue, immobiliareWeight: 20, altriWeight: 5 },
  {
    id: RowId.diversificazioneGeografica,
    immobiliareWeight: 0,
    altriWeight: 33,
  },
  {
    id: RowId.diversificazioneDiBusiness,
    immobiliareWeight: 0,
    altriWeight: 33,
  },
  { id: RowId.scoreSettoriale, immobiliareWeight: 100, altriWeight: 33 },
];
